import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { CancelGivingSubscriptionResponse } from './types';

type CancelMemberGivingSubscriptionParams = {
  memberId: string;
  givingSubscriptionId: string;
};

export async function cancelMemberGivingSubscription({
  memberId,
  givingSubscriptionId,
}: CancelMemberGivingSubscriptionParams) {
  const url = `/web/studio/users/${memberId}/giving-subscriptions/${givingSubscriptionId}/cancel`;

  const response = await api.executePostRequest<ObjectResponse<CancelGivingSubscriptionResponse>>(url);

  return response.data;
}
